import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {Invoke}    from "@Common/react/invoke";
import {UseState}  from "@Common/react/use-state";
import {equalDeep} from "@Common/utils/objects";

// This is different from ItemSaver in APM as this is active saving. Save on call
export const ActiveSaver = ({getInitBuffer, getLiveData, doSave, disabled, next}) => cs(
    ["buffer", (_, next) => UseState({getInitValue: getInitBuffer, next})],
    ["saving", (_, next) => UseState({next})],
    ({saving, buffer}) => fragments(
        next({
            save: async () => new Promise((resolve, reject) => {

                saving.onChange({resolve, reject});
            }),
        }),
        !disabled && saving.value && Invoke({
            action: async () => {
                const liveData = getLiveData();
                if (!equalDeep(liveData, buffer.value)) {
                    await doSave(liveData);
                    buffer.onChange(liveData);
                }
                saving.onChange(null);
                saving.value.resolve();
            },
        }),
    ),
);